import styled from "@emotion/styled";
import { FC } from "react";

import { Tag, TagKind, TagSize } from "@livechat/design-system-react-components";

import Role, { LiveChatRole } from "constants/role";

interface IProps {
  role: Role | LiveChatRole;
  size?: TagSize;
}

export const RoleFormattedValues: Record<Role | LiveChatRole, string> = {
  [Role.Owner]: "Admin",
  [LiveChatRole.Admin]: "Admin",
  [LiveChatRole.ViceOwner]: "Admin",
  [Role.Viewer]: "Viewer",
  [Role.Normal]: "Agent",
  [LiveChatRole.Normal]: "Agent",
  [LiveChatRole.Owner]: "Owner",
};

const agentRoleToTagKindMap: Record<Role | LiveChatRole, Extract<TagKind, "default" | "info" | "warning" | "black">> = {
  [Role.Owner]: "info",
  [LiveChatRole.Admin]: "info",
  [LiveChatRole.ViceOwner]: "info",
  [Role.Viewer]: "warning",
  [Role.Normal]: "default",
  [LiveChatRole.Normal]: "default",
  [LiveChatRole.Owner]: "black",
};

export const RoleTag: FC<IProps> = ({ role, size = "small" }) => {
  const tagKind = agentRoleToTagKindMap[role];

  return (
    <FitContentTag size={size} kind={tagKind} data-testid={`role-tag-${role}`}>
      {RoleFormattedValues[role]}
    </FitContentTag>
  );
};

const FitContentTag = styled(Tag)`
  min-width: fit-content;
`;
